import style from "styled-components";

export const HomeContainer = style.div`
width: 100%

`;
